import axios from "axios";
//带三方类库
import qs from 'qs'
import {ElMessage} from 'element-plus'
import {getCookie, delCookie} from '@/utils/cookie'
// 配置不同环境下，调用不同接口
const BASE_URL = process.env.NODE_ENV !== 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_SERVER_URL
// 对面暴露的基础请求路径
axios.defaults.baseURL = 'api'
/**
 * 设置超时时间和跨域是否允许携带凭证
 */
axios.defaults.timeout = 10000  //设置十秒
axios.defaults.withCredentials = true;//例如：登录校验session和cookie
/**
 * 设置请求数据参数传递的格式，默认是json格式，但是在登录校验中后台一般设置请求格式：x-www-form-urlencoded(name=xxx,age=xxx)
 * 看服务器要求什么格式
 */
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded' //声明请求格式
axios.defaults.transformRequest = data => qs.stringify(data)  //qs是第三方库，转换为x-www-form-urlencoded
/**
 * 设置请求拦截器：----在项目中发请求（请求没有发出去）可以做一些事情
 * 客户端->[请求拦截器]->服务器端
 * token校验（JWT）：接收到服务器的token,存储到vuex/本地存储中，每次向服务器发送请求，我们应该把token带上
 * config :发起请求的请求配置项
 */
axios.interceptors.request.use(config => {
    let token = getCookie('token')
    if (token) {
        // token 通过 Authorization 请求头携带（Bearer 方式），不再放 URL 参数，避免泄露到访问日志/Referer
        config.headers.Authorization = 'Bearer ' + token
    }
    return config
}, error => {
    return Promise.reject(error)
})
/**
 * 设置响应拦截器
 * 服务器端返回信息->[响应拦截器]->客户端js获取到信息
 * response中包含属性：
 * data：相应数据,status:响应状态码,statusText:响应状态信息,headers:响应头,config:响应提供的配置信息,request
 */
axios.interceptors.response.use(response => {
    return response.data //将主体内容返回  axios.get().then(result=>{拿到的就是响应主体})
}, error => {
    let {response} = error
    // 如果有返回结果
    if (response) {
        switch (response.status) {
            //登录凭证缺失/过期/失效：清理本地凭证并回到首页未登录态
            case 401:
                delCookie('token')
                if (window.location.pathname !== '/') {
                    window.location.href = '/'
                } else {
                    window.location.reload()
                }
                break;
            //进行错误跳转之类
            case 404:
                break;
            default:
                // 服务器异常给出明确提示，避免提交类操作静默失败让用户误以为没反应
                if (response.status >= 500) {
                    ElMessage.error('服务器繁忙，请稍后重试')
                }
        }
        return Promise.reject(error)
    } else {
        //服务器没有返回结果 分两种情况 断网 服务器崩了
        if (!window.navigator.onLine) {
            //断网处理：跳转到断网页面
            return
        }
        return Promise.reject(error)
    }
})

export default axios
